import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faFaceSmile, faHome } from '@fortawesome/free-solid-svg-icons';
import { FeatureToggleService } from '../feature-toggle/feature.service';

export interface NavigationItem {
  text: string;
  icon?: IconProp;
  image?: string;
  class?: string;
  routerLink: string;
}

const dashboardMenuItem: NavigationItem = {
  text: 'dashboard.singular',
  icon: 'home',
  routerLink: '/'
};

const teamMenuItem: NavigationItem = {
  text: 'team.singular',
  icon: 'face-smile',
  routerLink: '/team'
};

const customerMenuItem: NavigationItem = {
  text: 'customer.plural',
  icon: 'briefcase',
  routerLink: '/customer'
};
const projectsMenuItem: NavigationItem = {
  text: 'project.plural',
  icon: 'project-diagram',
  routerLink: '/projects'
};
const skillsMenuItem: NavigationItem = {
  text: 'skill.plural',
  icon: 'user-gear',
  routerLink: '/skills'
};
const usefulMenuItem: NavigationItem = {
  text: 'usefulLinks',
  icon: 'link',
  routerLink: '/useful'
};
const overviewMenuItem: NavigationItem = {
  text: 'overview.overview',
  icon: 'table-list',
  routerLink: '/overview',
}

export const navigationItems: NavigationItem[] = [
  dashboardMenuItem,
  teamMenuItem,
  customerMenuItem,
  projectsMenuItem,
  skillsMenuItem,
  usefulMenuItem,
  overviewMenuItem,
];

@Injectable({ providedIn: 'root' })
export class MainMenuService {
  constructor(
    private library: FaIconLibrary,
    private featureToggleService: FeatureToggleService
  ) {
    library.addIcons(faFaceSmile, faHome);
  }

  /*public getNavigationItems(): Observable<NavigationItem[]> {
    return of(navigationItems);
  }*/
  public getNavigationItems(): Observable<NavigationItem[]> {
    const filteredItems = navigationItems.filter(item => {
      if (item.routerLink === '/overview') {
        return this.featureToggleService.isEnabled('menu-item-overview');
      }
      return true;
    });

    return of(filteredItems);
  }
}
